export default (params) => ({
  trigger: {
    name: 'split_test.show_split_test',
    params: params,
  },
  config: {
    schema: {
      test_name: {
        type: 'string',
      },
      variation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'show_split_test',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
